(function() {
  const initRangeSlider = () => {
    const rangeWrapper = document.querySelector(".range-slider-wrapper");
    if (!rangeWrapper) return;

    const rangeMin = rangeWrapper.querySelector(".range-min");
    const rangeMax = rangeWrapper.querySelector(".range-max");
    const inputMin = document.querySelector(".price-input-labels .input-min");
    const inputMax = document.querySelector(".price-input-labels .input-max");
    const form = document.querySelector(".collection-filters__price-range-form");
    const progress = rangeWrapper.querySelector(".price-slider-progress");

    if (!rangeMin || !rangeMax || !inputMin || !inputMax || !form || !progress) return;

    const maxRange = parseFloat(rangeMin.max);
    let debounceTimer;


    const formatCurrency = (value) => {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    };

    const updateUI = () => {
      let minVal = parseFloat(rangeMin.value);
      let maxVal = parseFloat(rangeMax.value);

      if (minVal > maxVal) [minVal, maxVal] = [maxVal, minVal];

      // Update numeric inputs - only update from slider, not on manual input
      if (document.activeElement !== inputMin) {
        inputMin.value = Math.round(minVal);
      }
      if (document.activeElement !== inputMax) {
        inputMax.value = Math.round(maxVal);
      }

      // Update progress bar
      progress.style.left = (minVal / maxRange) * 100 + "%";
      progress.style.right = 100 - (maxVal / maxRange) * 100 + "%";
    };

    const applyFilter = () => {
      form.submit();
    };

    const handleDebouncedChange = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyFilter, 100);
    };

    // Slider events
    [rangeMin, rangeMax].forEach(input => {
      input.addEventListener("input", updateUI);
      input.addEventListener("change", handleDebouncedChange);
    });

    // Numeric input events
    [inputMin, inputMax].forEach((input, idx) => {
      input.addEventListener("input", () => {
        let val = input.value.replace(/[^\d]/g, ''); // Remove non-digits during typing
        if (val === '') {
          if (idx === 0) rangeMin.value = 0;
          else rangeMax.value = 0;
          return;
        }
        
        val = parseInt(val);
        if (isNaN(val) || val < 0) val = 0;
        if (val > maxRange) {
          val = maxRange;
          input.value = val;
        }

        // Additional validation: min can't exceed current max, max can't be less than current min
        if (idx === 0) {
          // This is the min input
          let currentMax = parseInt(inputMax.value) || maxRange;
          if (val > currentMax) {
            val = currentMax;
            input.value = val;
          }
          rangeMin.value = val;
        } else {
          // This is the max input
          let currentMin = parseInt(inputMin.value) || 0;
          if (val < currentMin) {
            val = currentMin;
            input.value = val;
          }
          rangeMax.value = val;
        }

        // Update only the progress
        let minVal = parseFloat(rangeMin.value);
        let maxVal = parseFloat(rangeMax.value);
        
        progress.style.left = (minVal / maxRange) * 100 + "%";
        progress.style.right = 100 - (maxVal / maxRange) * 100 + "%";
      });

      input.addEventListener("blur", () => {
        // Clean up value on blur
        let val = parseInt(input.value.replace(/[^\d]/g, ''));
        if (isNaN(val) || val < 0) val = 0;
        if (val > maxRange) val = maxRange;
        
        // Final validation on blur
        if (idx === 0) {
          let currentMax = parseInt(inputMax.value) || maxRange;
          if (val > currentMax) val = currentMax;
          rangeMin.value = val;
        } else {
          let currentMin = parseInt(inputMin.value) || 0;
          if (val < currentMin) val = currentMin;
          rangeMax.value = val;
        }
        
        input.value = val;
        handleDebouncedChange();
      });
    });

    updateUI(); // Initialize
  };

  document.addEventListener("DOMContentLoaded", initRangeSlider);
  document.addEventListener("shopify:section:load", initRangeSlider);
})();

